import { combineReducers } from 'redux-immutablejs';

import globalReducer from './global';
import totalEstimateReducer from './totalEstimate';
import justAppraisedReducer from './justAppraised';
import mineralImportReducer from './mineralImport';
import exemptionResetsReducer from './exemptionReset';
import integrityCheckReducer from './integrityCheck';
import processEx366Reducer from './processEx366';
import ptdProcessReducer from './ptdProcess';
import bppPenaltyReducer from './bppPenalty';
import buildingPermitReducer from './buildingPermit';
import taxLimitationReducer from './taxLimitation';
import newYearLayerReducer from './newYearLayer';
import massCassValidationReducer from './massCassValidation';
import massImportExemptionsReducer from './massImportExemptions';
import captureJanuary1OwnersReducer from './captureJanuary1Owners';
import hsAuditExportReducer from './hsAuditExport';
import massMatchSalesReducer from './massMatchSales';
import pinRetrievalRequestsReducer from './pinRetrievalRequests';

export default combineReducers({
  global: globalReducer,
  bppPenalty: bppPenaltyReducer,
  buildingPermit: buildingPermitReducer,
  captureJanuary1Owners: captureJanuary1OwnersReducer,
  exemptionReset: exemptionResetsReducer,
  hsAuditExport: hsAuditExportReducer,
  integrityCheck: integrityCheckReducer,
  justAppraised: justAppraisedReducer,
  massCassValidation: massCassValidationReducer,
  massImportExemptions: massImportExemptionsReducer,
  mineralImport: mineralImportReducer,
  newYearLayer: newYearLayerReducer,
  processEx366: processEx366Reducer,
  ptdProcess: ptdProcessReducer,
  taxLimitation: taxLimitationReducer,
  totalEstimate: totalEstimateReducer,
  massMatchSales: massMatchSalesReducer,
  pinRetrievalRequests: pinRetrievalRequestsReducer,
});
